export enum Classification {
  I = 1,
  II,
  III,
  IV
}

export enum Category {
  a = 1,
  b,
  c
}

export enum Application {
  HumanComfort = 1,
  OtherApplications,
  LessThanOnePerson
}

// export enum Refrigerant {
//   XL10 = "(R1234yf, GWP¹ = 4)",
//   XL20 = "(R454C, GWP¹ = 148)",
//   XL40 = "(R454A, GWP¹ = 239)",
//   XL41 = "(R454B, GWP¹ = 466)",
//   XL55 = "(R452B, GWP¹ = 698)"
// }

export enum Refrigerant {
  XL10,
  XL20,
  XL40,
  XL41,
  XL55
}

export type RoomDimensions = {
  height: number;
  width: number;
  length: number;
  square: Function;
  cubic: Function;
};

export enum HeightFactor {
  FloorLocation = 0.6,
  WindowMounted = 1,
  WallMounted = 1.8,
  CeilingMounted = 2.2
}

export type Fluid = {
  enabled: boolean;
  id: string;
  title: string;
  lfl: number;
  m1x1_5: number;
  m2a: number;
  m3b: number;
  qlmv: number;
  qlav: number;
  formula: string;
  description: string;
};

export type CalculationEnd = {
  c1: 0;
  qlmv: 0;
  qlav: 0;
};

export enum Restriction {
  NoRestriction
}

export interface Core {
  application: Application;
  classification: Classification;
  category: Category;
  refrigerant: Refrigerant;
}

export interface RoomBaseTest {
  height: string;
  width: string;
  length: string;
}

export interface RoomBase {
  height: number;
  width: number;
  length: number;
}

export interface Room extends RoomBase {
  square: number;
  cubic: number;
  qlsize: number;
}

export interface Calculations {
  [c1: string]: {
    [c2: string]:
      | {
          [c3: string]: {
            [c4: string]: number | Restriction.NoRestriction;
          };
        }
      | number
      | { min: number; max: number };
  };
}

export interface Calculations {
  OAs: {
    a: {
      i: {
        c1: number;
        qlmv: number;
        qlav: number;
      };
      ii: {
        c1: number;
        qlmv: number;
        qlav: number;
      };
      iii: {
        c1: Restriction.NoRestriction;
      };
      iv: {
        c1: number;
      };
    };
    b: {
      i: {
        c1: number;
        qlmv: number;
        qlav: number;
      };
      ii: {
        c1: number;
        qlmv: number;
        qlav: number;
      };
      iii: {
        c1: Restriction.NoRestriction;
      };
      iv: {
        c1: number;
      };
    };
    c: {
      i: {
        c1: number;
        qlmv: number;
        qlav: number;
      };
      ii: {
        c1: number;
        qlmv: number;
        qlav: number;
      };
      iii: {
        c1: Restriction.NoRestriction;
      };
      iv: {
        c1: number;
      };
    };
  };
  OAn: {
    a: {
      i: {
        c1: number;
        qlmv: number;
        qlav: number;
      };
      ii: {
        c1: number;
        qlmv: number;
        qlav: number;
      };
      iii: {
        c1: Restriction.NoRestriction;
      };
      iv: {
        c1: number;
      };
    };
    b: {
      i: {
        c1: number;
        qlmv: number;
        qlav: number;
      };
      ii: {
        c1: number;
        qlmv: number;
        qlav: number;
      };
      iii: {
        c1: Restriction.NoRestriction;
      };
      iv: {
        c1: number;
      };
    };
    c: {
      i: {
        c1: number;
        qlmv: number;
        qlav: number;
      };
      ii: {
        c1: number;
        qlmv: number;
        qlav: number;
      };
      iii: {
        c1: Restriction.NoRestriction;
      };
      iv: {
        c1: number;
      };
    };
  };
  LOs: {
    c: {
      i: {
        c1: number;
        qlmv: number;
        qlav: number;
      };
      ii: {
        c1: Restriction.NoRestriction;
      };
    };
  };
  LOn: {
    c: {
      i: {
        c1: number;
        qlmv: number;
        qlav: number;
      };
      ii: {
        c1: Restriction.NoRestriction;
      };
    };
  };
  HC: {
    a: {
      i: {
        c2: number;
        qlmv: number;
        qlav: number;
      };
      ii: {
        c2: number;
        qlmv: number;
        qlav: number;
      };
      iii: {
        c2: Restriction.NoRestriction;
      };
      iv: {
        c2: number;
      };
    };
    b: {
      i: {
        c2: number;
        qlmv: number;
        qlav: number;
      };
      ii: {
        c2: number;
        qlmv: number;
        qlav: number;
      };
      iii: {
        c2: Restriction.NoRestriction;
      };
      iv: {
        c2: number;
      };
    };
    c: {
      i: {
        c2: number;
        qlmv: number;
        qlav: number;
      };
      ii: {
        c2: number;
        qlmv: number;
        qlav: number;
      };
      iii: {
        c2: Restriction.NoRestriction;
      };
      iv: {
        c2: number;
      };
    };
  };
  OR: {
    x: number;
    c22_c3: { min: number; max: number };
    c22_c4: { min: number; max: number };
    c22_c5: { min: number; max: number };
  };
}
